import { Tooltip } from '@mui/material';
import { ChatController } from '../chat.controller';

import styles from './fileContext.module.scss';

const FileContextComponent: React.FC<{ fileName: string, setFileName: any, currChatContext: any }> = ({ fileName, setFileName, currChatContext }) => {

    const extensionFile = fileName.split('.').pop();
    let extensionType = '';

    switch (extensionFile) {
        case 'pdf':
            extensionType = 'Pdf';
            break;
        case 'doc':
            extensionType = 'Doc';
            break;
        case 'docx':
            extensionType = 'Doc';
            break;
        case 'xls':
            extensionType = 'Xls';
            break;
        case 'xlsx':
            extensionType = 'Xls';
            break;
        case 'csv':
            extensionType = 'Csv';
            break;
        default:
            extensionType = 'File';
            break;
    }
   
    const handleRemoveFile = (fileName: any) => {
        const Chat_Controller = new ChatController();
        Chat_Controller.RemoveFile(currChatContext.currChat.data_sources[0].parameters.ephemeralId)
        .then(() => {
            // Remove previous conversation
            currChatContext.setUserAsks([]);
            currChatContext.setIaAnswers([]);
            // Remove conversation
            currChatContext.setCurrChat((prevCurrChat: any) => {
                // Remove chat history
                prevCurrChat.messages = [];
                // Indicate start new document
                prevCurrChat['data_sources'][0]['parameters']['new_document'] = true;
                // Remove ephemeralId
                prevCurrChat['data_sources'][0].parameters.ephemeralId = null;       
                return prevCurrChat;
            });

            setFileName((prevArray: any) => [...prevArray.filter((item: any) => item !== fileName)]);

        })
        .catch(() => {
            alert("Error al borrar el archivo, pruebe de nuevo.")
        })
    };

    return (
        <div className={styles.fileContextComponent}>
            <div className={styles.fileContextComponentContent}>
                <span className={`${styles['fileContextComponent' + extensionType]}`}></span>
                <Tooltip enterNextDelay={200} placement="top" arrow title={fileName}>
                    <span className={styles.fileContextComponentName}>
                        {fileName}
                    </span>
                </Tooltip>
            </div>
        </div>
    )
}

export { FileContextComponent }


